//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';

//components
import { Layout, Title, Paragraph } from '@/components/Typography/Legal';
import { Table } from '@/components/Typography/Table';
import { HubspotFormSimplified } from '@/containers-m/HubspotFormSimplified';

//vendor
import { subprocessorsOptions } from '@/vendor/HubspotFormIntegration';

//styles
import { FormWrapper } from './Legal.styles';
import { Title2 } from '@/components/Text';

const list_01 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Amazon Web Services',
      'Cloud hosting, object storage (S3), queues (SQS/SNS), CDN (CloudFront), managed databases (RDS, DynamoDB, ElastiCache), secrets management (KMS)',
      'United States',
    ],
    [
      'Elastic Cloud',
      'Managed Elasticsearch for full-text search and document indexing',
      'United States',
    ],
    ['CloudAMQP', 'Managed RabbitMQ message broker', 'United States'],
  ],
};

const list_02 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Datadog',
      'APM, distributed tracing, Real User Monitoring (RUM), metrics, and log aggregation',
      'United States',
    ],
    [
      'Sentry',
      'Application error tracking and exception monitoring',
      'United States',
    ],
  ],
};
const list_03 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Mixpanel',
      'Product analytics, event tracking, user behavior analysis',
      'United States',
    ],
    ['Hotjar', 'Session recording, heatmaps, and user behavior analysis', 'EU'],
    ['Beamer', 'In-app product announcements and changelog', 'United States'],
    [
      'Delighted (Qualtrics)',
      'NPS surveys for customer satisfaction',
      'United States',
    ],
    [
      'ZoomInfo',
      'B2B web visitor identification and marketing intelligence',
      'United States',
    ],
    ['Fathom', 'AI note-taker used by Sales', 'United States'],
  ],
};
const list_04 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    ['Twilio', 'SMS delivery to drivers and carriers', 'United States'],
    ['Mailgun', 'Transactional email delivery', 'United States'],
    ['Mailchimp / Mandrill', 'Transactional email delivery', 'United States'],
    ['SendGrid', 'Transactional email delivery', 'United States'],
    [
      'Slack',
      'Internal notifications and alerts containing operational data',
      'United States',
    ],
    [
      'Pusher',
      'Real-time WebSocket messaging and live updates',
      'United States',
    ],
    ['TalkJS', 'In-app chat and messaging platform', 'EU'],
  ],
};
const list_05 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Salesforce',
      'CRM, live chat support, shipment event sync',
      'United States',
    ],
    ['HubSpot', 'Marketing platform and lead capture forms', 'United States'],
    ['Zendesk', 'Customer support ticketing', 'United States'],
    ['Intercom', 'In-app customer messaging and support chat', 'United States'],
    ['Salesloft', 'Sales engagement platform', 'United States'],
    [
      'Orum',
      'AI-powered live conversation platform for Sales',
      'United States',
    ],
  ],
};
const list_06 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Stripe',
      'Payment processing and credit card collection',
      'United States',
    ],
    ['Bill.com', 'Financial operations platform', 'United States'],
    [
      'NetSuite (Oracle)',
      'ERP / accounting integration and financial data sync',
      'United States',
    ],
    [
      'Intuit QuickBooks',
      'Accounting sync for invoices and customers',
      'United States',
    ],
    [
      'TriumphPay',
      'Carrier factoring, payments, and fuel cards',
      'United States',
    ],
    ['WEX', 'Fleet fuel card transactions', 'United States'],
    [
      'BasicBlock',
      'Invoice factoring and broker verification',
      'United States',
    ],
    ['RTS Financial', 'Invoice factoring via SFTP', 'United States'],
    [
      'Relay Payments',
      'Prepaid payment codes and payment processing',
      'United States',
    ],
  ],
};
const list_07 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'OpenAI',
      'LLM processing for smart EDI extraction and data analysis at ShipperGuide',
      'United States',
    ],
    [
      'Anthropic',
      'LLM for data model schema generation at the EDI Platform',
      'United States',
    ],
  ],
};
const list_08 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Google Maps Platform',
      'Maps, geocoding, Places API, distance matrix, and timezone APIs',
      'United States',
    ],
    ['Mapbox', 'Mapping and location services', 'United States'],
    [
      'PC*Miler (Trimble)',
      'Truck routing and mileage calculations',
      'United States',
    ],
    ['Rand McNally', 'Route optimization for shipments', 'United States'],
  ],
};
const list_09 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Project44',
      'Supply-chain visibility and shipment tracking',
      'United States',
    ],
    [
      'SMC3',
      'LTL pricing, dispatch, tracking, and PRO assignment',
      'United States',
    ],
    [
      'DAT Freight &amp; Analytics',
      'Load board and freight marketplace',
      'United States',
    ],
    [
      'MacroPoint (Descartes)',
      'Real-time shipment visibility and ETA',
      'Canada / United States',
    ],
    [
      'Convoy',
      'Real-time location tracking and milestone updates',
      'United States',
    ],
    [
      'C.H. Robinson',
      'Load and shipment integration (Navisphere)',
      'United States',
    ],
    ['3GTMS', 'Transportation Management System integration', 'United States'],
    ['G2 Mint', 'Freight quoting and pricing', 'United States'],
    ['Arachne', 'Quote management and TMS integration', 'United States'],
    ['FlockFreight', 'Shared truckload shipping', 'United States'],
    [
      'Blujay / E2open',
      'EDI message transport (AS2) for carrier integrations',
      'United States',
    ],
    [
      'BoldVan',
      'EDI message transport (AS2) for carrier integrations',
      'United States',
    ],
    ['Svix', 'Webhook delivery and signing infrastructure', 'United States'],
    [
      'Penske (Mercury Gate)',
      'TMS integration for Penske shipments',
      'United States',
    ],
  ],
};
const list_10 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'SaferWatch',
      'Carrier safety and compliance monitoring (CSA/FMCSA data)',
      'United States',
    ],
    [
      'Highway',
      'Carrier identity, capacity data, and onboarding',
      'United States',
    ],
    [
      'Motive (KeepTruckin)',
      'ELD, HOS compliance, driver documents',
      'United States',
    ],
    ['Samsara', 'GPS tracking, HOS, vehicle diagnostics', 'United States'],
    ['Geotab', 'Vehicle telematics and diagnostics', 'Canada / United States'],
    ['Omnitracs', 'Fleet management and telematics', 'United States'],
    ['Spireon', 'GPS vehicle tracking', 'United States'],
  ],
};
const list_11 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Unleash',
      'Feature flags and gradual rollouts (self-hosted)',
      'Self-hosted',
    ],
    [
      'Google Firebase',
      'Remote config, feature flags, push notifications (FCM), dynamic links',
      'United States',
    ],
    [
      'Google reCAPTCHA',
      'Bot protection on signup and public forms',
      'United States',
    ],
  ],
};
const list_12 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'Google Workspace',
      'Email, office productivity tools, and shared documents',
      'United States',
    ],
    [
      'Microsoft',
      'Office productivity, Power BI, Azure services',
      'United States',
    ],
    ['DocuSign', 'Electronic agreement management', 'United States'],
    ['Loop', 'Document audit provider', 'United States'],
    [
      'Atlassian (Jira / Confluence)',
      'Project management and team documentation',
      'United States',
    ],
  ],
};
const list_13 = {
  header: ['Entity Name', 'Applicable Services', 'Location of Processing'],
  body: [
    [
      'CircleCI',
      'CI/CD pipeline execution (may incidentally process data in build logs)',
      'United States',
    ],
    [
      'GitHub (Microsoft)',
      'Source code hosting and code review',
      'United States',
    ],
  ],
};
const list_14 = {
  header: ['Entity Name', 'Location of Processing'],
  body: [
    ['Opendock LLC', 'United States'],
    ['Carrier Solutions LLC', 'United States'],
  ],
};

const Subprocessors = () => {
  return (
    <>
      <Navigation />
      <>
        <Layout>
          <Title>List of Sub-Processors</Title>
          <Paragraph>
            <em>Last Updated: April 9, 2026</em>
          </Paragraph>

          <Title2>Cloud Infrastructure &amp; Hosting</Title2>
          <Table content={list_01} />
          <Title2>Monitoring, Observability &amp; Error Tracking</Title2>
          <Table content={list_02} />
          <Title2>Analytics &amp; User Behavior</Title2>
          <Table content={list_03} />
          <Title2>Communication &amp; Notifications</Title2>
          <Table content={list_04} />
          <Title2>CRM, Sales, Marketing &amp; Customer Support</Title2>
          <Table content={list_05} />
          <Title2>Payments, Financial Services &amp; Accounting</Title2>
          <Table content={list_06} />
          <Title2>AI &amp; Machine Learning</Title2>
          <Table content={list_07} />
          <Title2>Maps, Geolocation &amp; Routing</Title2>
          <Table content={list_08} />
          <Title2>Transportation, Logistics &amp; Freight Partners</Title2>
          <Table content={list_09} />
          <Title2>Carrier Compliance, Safety &amp; Telematics</Title2>
          <Table content={list_10} />
          <Title2>Feature Management &amp; Product Experience</Title2>
          <Table content={list_11} />
          <Title2>Documents, Agreements &amp; Productivity</Title2>
          <Table content={list_12} />
          <Title2>CI/CD &amp; DevOps</Title2>
          <Table content={list_13} />
          <Title2>Affiliates</Title2>
          <Paragraph>
            In addition, depending on the scope of Services provided by
            Loadsmart, Loadsmart may engage one or more of its affiliates as
            Sub-Processors to provide support with respect to the Services.
          </Paragraph>
          <Table content={list_14} />
        </Layout>

        <FormWrapper id="fill-the-form">
          <HubspotFormSimplified
            theme="light"
            {...subprocessorsOptions}
            content={{
              title:
                'Would you like to receive notice of updates to Loadsmart’s Sub-Processor list?',
              subtitle:
                'Please fill out this form to receive notifications regarding updates to Loadsmart’s Sub-Processors. If you are a Controller of Personal Information which Loadsmart Processes, you have the right to object to any changes to the above list.',
            }}
          />
        </FormWrapper>
      </>
      <Footer />
    </>
  );
};

export default Subprocessors;
export { Subprocessors };
